import SubjectService from "../SubjectService"
import SubjectOrderEntity from "../Entity/SubjectOrderEntity"

const
    FETCHING_RECORDS = "FETCHING_RECORDS",
    FETCHING_RECORDS_SUCCESS = "FETCHING_RECORDS_SUCCESS",
    FETCHING_RECORDS_ERROR = "FETCHING_RECORDS_ERROR",
    CLEAR_RECORDS = "CLEAR_RECORDS"

const initialState = {
    isLoading: false,
    records: [],
}

export const state = {...initialState}

export const actions = {

    async loadOrders({commit}, id) {
        try {
            commit(FETCHING_RECORDS)
            let response = await SubjectService.getSubjectOrders(id)
            commit(FETCHING_RECORDS_SUCCESS, response.data)
            return state.records
        } catch (error) {
            commit(FETCHING_RECORDS_ERROR, error)
            return Promise.reject(error)
        }
    },

    clearAll({commit}) {
        commit(CLEAR_RECORDS)
    },

}

export const mutations = {

    [FETCHING_RECORDS](state) {
        state.isLoading = true
        state.records = []
    },
    [FETCHING_RECORDS_SUCCESS](state, records) {
        state.isLoading = false
        state.records = records.map(order => SubjectOrderEntity.from(order))
    },
    [FETCHING_RECORDS_ERROR](state) {
        state.isLoading = false
        state.records = []
    },

    [CLEAR_RECORDS](state) {
        state.isLoading = false
        state.records = []
    },

}

export const getters = {

    isLoading(state) {
        return state.isLoading
    }, hasRecords(state) {
        return state.records.length > 0
    }, getRecords(state) {
        return state.records
    },

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
